module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'x8wf80x0',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
